'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import { trackCTAClick } from '@/lib/analytics';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-primary to-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-golden-light to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-tl from-golden-mid to-transparent rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="BoltIcon" size={20} className="text-golden-light" />
            <span className="font-cta font-semibold text-sm text-white">Get Started Today</span>
          </div>

          <h2 className="font-headline font-bold text-3xl lg:text-5xl text-white mb-6 leading-tight">
            Ready to Transform Your Logistics Operations?
          </h2>
          
          <p className="font-body text-lg lg:text-xl text-gray-200 mb-10 leading-relaxed max-w-2xl mx-auto">
            Join Africa's leading mining and EPC companies who trust MylesDrive for their critical logistics needs. Get a customized quote in 24 hours.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/contact-and-quotes"
              onClick={() => trackCTAClick('Request a Quote', 'Homepage Hero', '/contact-and-quotes')}
              className="inline-flex items-center space-x-2 px-8 py-4 font-cta font-semibold text-base text-primary bg-gradient-to-r from-golden-light via-golden-mid to-golden-dark rounded-lg shadow-golden-lg hover:shadow-golden-xl transition-all duration-300 hover:-translate-y-1"
            >
              <Icon name="DocumentTextIcon" size={20} />
              <span>Request a Quote</span>
            </Link>

            <Link
              href="/services-overview"
              onClick={() => trackCTAClick('Explore Services', 'Homepage Hero', '/services-overview')}
              className="inline-flex items-center space-x-2 px-8 py-4 font-cta font-semibold text-base text-white bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-lg hover:bg-white/20 transition-all duration-300"
            >
              <Icon name="TruckIcon" size={20} />
              <span>Explore Services</span>
            </Link>
          </div>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="font-headline font-bold text-3xl text-golden-light mb-2">24/7</div>
              <div className="font-body text-sm text-gray-300">Support Available</div>
            </div>
            <div className="text-center">
              <div className="font-headline font-bold text-3xl text-golden-light mb-2">&lt;24h</div>
              <div className="font-body text-sm text-gray-300">Quote Response Time</div>
            </div>
            <div className="text-center">
              <div className="font-headline font-bold text-3xl text-golden-light mb-2">98.7%</div>
              <div className="font-body text-sm text-gray-300">On-Time Delivery</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;